@if (this.grid && this.grid.api) {
  <div class="fields-selection flex-column g-space-sm p-space-md">
    <cam-search-field [isOpen]="true" [input]="this.searchInput"></cam-search-field>

    <cam-empty class="fields-selection__list" [isEmpty]="!this.hasColumns()" text="grid.fieldsselection.empty">
      @for (col of this.columns(); track col.getId()) {
        <div
          class="fields-selection__row flex-row g-space-sm align-center"
          [class.is-disabled]="this.model(col).readonly"
        >
          <cam-input-toggle
            [input]="this.model(col)"
            (valueChanged)="this.onToggle(col, $any($event))"
          ></cam-input-toggle>
          <cam-text
            class="fields-selection__label"
            size="md"
            [color]="this.model(col).value ? 'primary' : 'secondary'"
            (click)="this.flip(col)"
          >
            {{ this.displayLabel(col) }}
          </cam-text>
        </div>
      }
    </cam-empty>

    <div class="fields-selection__actions flex-column g-space-sm">
      <cam-button type="secondary" size="medium" icon="eye" (action)="this.showAll()">
        {{ 'grid.fieldsselection.showall' | translate }}
      </cam-button>
      <cam-button type="secondary" size="medium" icon="arrow-go-back-line" (action)="this.reset()">
        {{ 'grid.fieldsselection.reset' | translate }}
      </cam-button>
    </div>
  </div>
}
